import { render } from "./TextAlert.vue?vue&type=template&id=25a8ab2a&scoped=true&ts=true"
import script from "./TextAlert.vue?vue&type=script&lang=ts"
export * from "./TextAlert.vue?vue&type=script&lang=ts"

import "./TextAlert.vue?vue&type=style&index=0&id=25a8ab2a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a8ab2a"]])

export default __exports__